import {Filters} from '../../constants/filter/filters';
import {CatalogFilterOptionsStoreClass} from './base';
import Dispatcher from "../../dispatcher";

class VehicleCatalogFilterOptionsStoreClass extends CatalogFilterOptionsStoreClass {
    getInitialState() {
        const vehicleOptions = [
            Filters.VEHICLE_MAKE,
            Filters.VEHICLE_MODEL,
            Filters.VEHICLE_YEAR,
            Filters.VEHICLE_ENGINE,
            Filters.VEHICLE_SERIES_CHASSIS,
            Filters.VEHICLE_DETAILS,
            Filters.VEHICLE_TYRES,
        ];
        return super.initFilterOptions(vehicleOptions);
    }
}

const VehicleCatalogFilterOptionsStore = new VehicleCatalogFilterOptionsStoreClass(Dispatcher);
export default VehicleCatalogFilterOptionsStore;
